import { Injectable, Injector } from "@angular/core";
import { BefRepository, ResponseInfo } from "@farris/bef";
import { Repository } from '@farris/devkit';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { Prop } from "./types";
import { BasePathService } from "@farris/rtf";

@Injectable()
export class FeatureRepository {
  constructor(
    private injector: Injector,
    private repository: Repository<any>,
  ) { }
  /**
   * æ ¹æ®ç©æidè·åç©æç¹å¾é¡¹åç¹å¾å¼ï¼å¬å±é»è®¤å¼ï¼
   * @param materialId ç©æid
   */
  public getFeaturesByMaterialId(materialId: string): Observable<ResponseInfo> {
    const url = BasePathService.convertPath('/api/scm/scmfnd/v1.0/scmcommoncmpservice/service/getmaterialprops');
    const body = {
      materialID: materialId
    };
    const options = {
      body
    };
    const befRepository: BefRepository<any> = this.repository as BefRepository<any>;
    return befRepository.proxy.request(url, 'put', null, options);
  }
  /**
   * æ ¹æ®ç©æidåç©æç¹å¾ä¿å­åçhashè·åè¯¥ç©æå·²ç»å­å¨çç¹å¾é¡¹å¼
   * @param materialId ç©æId
   * @param configID å¯¹åºè¯¥ç©æçç¹å¾é¡¹hash
   * @returns
   */
  public getConfigedValueByFeatureId(materialId: string, configID: string, configType: string = 'Materials'): Observable<ResponseInfo> {
    const url = BasePathService.convertPath('/api/bf/df/v1.0/charactconfigservice/service/getcharactconfiginfo');
    const body = { objType: configType, objID: materialId, configID };
    const befRepository: BefRepository<any> = this.repository as BefRepository<any>;
    const options = {
      body
    };
    return befRepository.proxy.request(url, 'put', null, options);
  }
  /**
   * ä¿å­ç©æç¹å¾é¡¹
   * @param materialId ç©æid
   * @param charactValue ç¹å¾å¼
   * @param configType éç½®ç±»å
   * @returns
   */
  public applyFeatures(materialId: string, charactValue: any, configType: string = 'Materials') {
    const body = { objType: configType, objID: materialId, charactValue };
    const befRepository: BefRepository<any> = this.repository as BefRepository<any>;
    const options = {
      body
    };
    return befRepository.proxy.request(BasePathService.convertPath('/api/bf/df/v1.0/charactconfigservice/service/matchcharactconfigid'), 'put', null, options);
  }
  /**
   * è·åå¸®å©ä¿¡æ¯
   * @param helpid å¸®å©id
   * @param filter è¿æ»¤æ¡ä»¶
   * @param params åæ°
   * @returns
   */
  public getHelpInfo(helpid: string, filter: string, params: any): Observable<any> {
    const url = BasePathService.convertPath('/api/scm/scmfnd/v1.0/scmcommoncmpservice/service/gethelpdata');
    const httpParams: any = {};
    if (params) {
      if (params.pageIndex) {
        httpParams['pageIndex'] = JSON.stringify(params.pageIndex - 0);
      }
      if (params.pageSize) {
        httpParams['pageSize'] = JSON.stringify(params.pageSize - 0);
      }
      if (params.condition) {
        httpParams['condition'] = JSON.stringify(params.condition);
      }
      if (params.searchValue) {
        httpParams['search'] = params.searchValue;
      }
    }
    const body = {
      helpID: helpid,
      queryParam: JSON.stringify(httpParams),
      filterStr: filter
    };
    const befRepository: BefRepository<any> = this.repository as BefRepository<any>;
    const options = {
      body
    };
    return befRepository.proxy.request(url, 'put', null, options);
  }
}
